var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSingleBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M273.379,166.329c-11.317,1.133 -20.029,10.771 -20.017,22.142l0,364.608l-24.27,0c-56.042,0 -101.896,45.875 -101.896,101.942l-0,282.858c0.025,12.146 9.996,22.138 22.141,22.183l64.821,0l0,100.9c-0.004,0.163 -0.004,0.321 -0.004,0.48c0,12.2 10.033,22.237 22.233,22.237c12.196,0 22.234,-10.037 22.234,-22.237c-0,-0.159 -0,-0.317 -0.004,-0.48l-0,-100.9l733.416,0l0,100.9c0,0.167 -0.004,0.334 -0.004,0.5c0,12.196 10.038,22.234 22.234,22.234c12.199,-0 22.237,-10.038 22.237,-22.234c-0,-0.166 -0.004,-0.333 -0.008,-0.5l-0,-100.9l64.17,0c12.146,-0.045 22.117,-10.037 22.142,-22.183l0,-282.858c0,-56.042 -45.683,-101.942 -101.725,-101.942l-23.791,0l-0,-364.608c-0.046,-12.192 -10.121,-22.188 -22.317,-22.142l-699.467,0c-0.708,-0.033 -1.416,-0.033 -2.125,0Zm24.442,44.458l654.966,0l0,342.292l-109.583,0l0,-118.612c0,-30.134 -24.95,-55.138 -55.137,-55.138l-325.959,0c-30.187,0 -55.137,25.004 -55.137,55.138l-0,118.612l-109.15,0l-0,-342.292Zm501.988,341.995l-344.58,-1.919l0.96,-129.382c0,0 342.483,-3.764 342.483,-1.252l1.137,132.553Zm-570.717,44.801l791.987,0c32.196,0 57.267,25.246 57.267,57.438l-0,49.712l-906.692,0l0,-49.712c0,-32.167 25.246,-57.438 57.438,-57.438Zm-57.438,151.609l906.692,-0l-0,166.37l-906.692,0l0,-166.37Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleBed);
export default __webpack_public_path__ + "static/media/single_bed.4c04f810.svg";
export { ForwardRef as ReactComponent };